import React, { useState } from "react";
import styles from "./OtpVerification.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex, passwordRegex } from "utils/regex";
import { LOGIN } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import LoginLayout from "components/layouts/loginlayout/LoginLayout";
import * as Yup from "yup"
import { combineClasses, requiredMessage } from "utils/utils";
import { Form, Formik } from 'formik';
import FormikControl from "components/formikcontrols/FormikControl";
import Button from 'components/shared/button/Button';
import { PATH } from "utils/constants";
import { ReactComponent as VerifiedIcon } from "assets/svg/verified.svg"
import { ReactComponent as BackIcon } from "assets/svg/arrow-left.svg"
import { IconButton, InputAdornment, InputLabel, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const VerifyPassword = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);


    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    const handleTogglePasswordVisibility2 = () => {
        setShowConfirm((prev) => !prev);
    };


    const passwordInstructions = [
        "contain atleast 1 lowercase character",
        "contain atleast 1 uppercase character",
        "contail atleast 1 special character",
        "be at least 8 characters long",
        "be maximum 20 characters long"
    ]

    const initialValues = {
        password: "",
        confirm: "",
    }

    const validationSchema = Yup.object({
        password: Yup.string()
            .required(requiredMessage("Password"))
            .matches(passwordRegex, "Invalid Password Format"),
        confirm: Yup.string()
            .required(requiredMessage("Password"))
            .when("password", ([password], schema) => {
                return schema.test("passwordMatch", "Passwords don't match!", (value) => {
                    return value === password
                })
            })
    })

    const login = (values) => {
        return publicRequest.post(LOGIN, values).then((res) => {
            localStorage.setItem("token", res?.data?.token)
            localStorage.setItem("currentUser", JSON.stringify(res?.data || {}))
            localStorage.setItem("email", values.email)
            navigate("/")
        })
    }

    const handleSubmit = async (values) => {
        const p = login(values)
        await toast.promise(p, {
            loading: "Logging in...",
            success: () => "Login Successful",
            error: () => "Invalid Email or Password",
        })
    };

    return (
        <LoginLayout>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {formik => {
                    return (
                        <div className={styles.mainDiv}>
                            <BackIcon
                                onClick={() => navigate(PATH.publicRoutes.FORGOT_PASSWORD.path)}
                                className={styles.backIcon}
                            />
                            <p className={styles.heading}>Reset Password,</p>
                            <p className={styles.subHeading}>{location?.state?.email} <VerifiedIcon className={styles.verifiedIcon} /></p>
                            <Form className={styles.form} autoComplete="off">
                                <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                                    Password<span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                {/* <FormikControl
                                    name="password"
                                    control="password"
                                    type="password"
                                    label="Password"
                                    placeholder="Enter Password"
                                    isRequired={true}
                                /> */}
                                <TextField
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                    onBlur={formik.handleBlur}
                                    name="password"
                                    size="small"
                                    type={showPassword ? "text" : "password"}
                                    margin="normal"
                                    className={styles.marginTop2px}
                                    placeholder="Enter Password"
                                    error={Boolean(
                                        formik.errors.password && formik.touched.password
                                    )}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            margin: "2px 0px",
                                        },
                                    }}
                                    helperText={
                                        formik.errors.password &&
                                        formik.touched.password &&
                                        String(formik.errors.password)
                                    }
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleTogglePasswordVisibility}
                                                    edge="end"
                                                    aria-label="toggle password visibility"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                                    Re-enter Password<span style={{ color: "red" }}>*</span>
                                </InputLabel>

                                {/* <FormikControl
                                    name="confirm"
                                    control="password"
                                    type="password"
                                    label="Re-enter Password"
                                    placeholder="Enter Password"
                                    isRequired={true}
                                /> */}
                                <TextField
                                    onChange={formik.handleChange}
                                    value={formik.values.confirm}
                                    onBlur={formik.handleBlur}
                                    name="confirm"
                                    size="small"
                                    type={showConfirm ? "text" : "password"}
                                    margin="normal"
                                    className={styles.marginTop2px}
                                    placeholder="Enter Password"
                                    error={Boolean(
                                        formik.errors.confirm && formik.touched.confirm
                                    )}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            margin: "2px 0px",
                                        },
                                    }}
                                    helperText={
                                        formik.errors.confirm &&
                                        formik.touched.confirm &&
                                        String(formik.errors.confirm)
                                    }
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleTogglePasswordVisibility2}
                                                    edge="end"
                                                    aria-label="toggle password visibility"
                                                >
                                                    {showConfirm ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    type="submit"
                                    className={styles.button}
                                    disabled={formik.isSubmitting}
                                >
                                    Submit
                                </Button>
                            </Form>
                            <div className={styles.passwordNotes}>
                                <strong>Note: </strong>
                                Password must -
                                <ul>
                                    {passwordInstructions.map(instruction => (
                                        <li>{instruction}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )
                }}
            </Formik>
        </LoginLayout>
    );
};

export default VerifyPassword;
